import React from 'react'
import img_one from './img_one.jpg'
import monetwo from './monetwo.png'
import monethree from './monethree.png'



export default function 
() {
  return (
    

<div className='.container' id='docs_container'>
        <h5 id='docs_title' >3 most discussed mental health topics</h5>
        <hr id='docs_divider'></hr>



<div class="card-zero">
  <img class="card-img-top" src={monetwo} alt="Card image cap"/>
  <div class="card-body">
    <p class="card-text">Attention-Deficit/Hyperactivity Disorder (ADHD)</p>
  </div>
</div>


<div class="card_two">
  <img class="card-img-bottom" src={img_one} alt="Card image cap"/>
  <div class="card-body">
    <p class="card-text">Obsessive-Compulsive Disorder (OCD)</p>
  </div>
</div>


<div class="card_three">
  <img class="card-img-middle" src={monethree} alt="Card image cap"/>
  <div class="card-body">
    <p class="card-text">Schizophrenia</p>
  </div>
</div>




</div>







        

        


       

    
  )
}
